import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { AuthGuardService } from "./services/auth/auth-guard.service";
import { ForgotResetpasswordComponent } from "./pages/forgot-resetpassword/forgot-resetpassword.component";
import { VerifyTimesheetComponent } from "./pages/verify-timesheet/verify-timesheet.component";
import { VerifyTimesheetViewComponent } from "./pages/verify-timesheet-view/verify-timesheet-view.component";
const routes: Routes = [
  {
    path: "forgot-resetpassword",
    component: ForgotResetpasswordComponent,
  },

  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("src/app/layouts/admin-layout/admin-layout.module").then(
            (m) => m.AdminLayoutModule
          ),
      },
    ],
    canActivate: [AuthGuardService],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("src/app/layouts/auth-layout/auth-layout.module").then(
            (m) => m.AuthLayoutModule
          ),
      },
    ],
  },
  {
    path: "verify-timesheet",
    component: VerifyTimesheetComponent,
  },
  {
    path: "verify-timesheet-view/:id",
    component: VerifyTimesheetViewComponent,
    data: { parentPath: "verify-timesheet" },
  },
  {
    path: "**",
    redirectTo: "dashboard",
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [],
})
export class AppRoutingModule {}
